import React from "react";
import { useState, useEffect } from "react";
import {ProductList} from "../ProductList";
import { useSettings } from "../Context/SettingsContext";
import { useLocation } from "react-router-dom";

function AllProducts()
{
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = React.useState(null);
    const settings = useSettings();
    const location = useLocation();

    useEffect(() => {

        const fetchProducts = async () => {
            try {

            setLoading(true);
            setError(null);

            const response = await fetch(`${settings.ApiUrl}/Stock/GetAllProducts`);

            if (!response.ok){
                setError('Ha ocurrido un problema al obtener los productos. Intenta más tarde.');
            }
            else{
                const data = await response.json();
                setProducts(data);
            }
            
            } catch (err) {
            setError(err.message);   
            setProducts([]);
            
            } finally {
            setLoading(false);
            }
        };

        fetchProducts();       
    
    }, []); 


    if (error) {
        return (
        <div className="error-message">          
            <p>Por favor, inténtalo de nuevo más tarde.</p>
        </div>
        );
    }

    return (
        <div>        
        <ProductList products={products} 
          title='Todos los Productos' 
          loading={loading} 
          location={location.key}/>
        </div>
    );   

};

export { AllProducts };